import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, doc, deleteDoc, updateDoc, DocumentReference, setDoc, query, where, addDoc} from '@angular/fire/firestore';
import { getDownloadURL, getStorage, ref, uploadString } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {
	constructor(
		private firestore: Firestore,
		private sharedService: SharedService
	) { }

	async addEditOrganisation(data: any, id: string) {
		return new Promise(async (resolve) => {
			// console.log("data", data);
			// console.log("id", id);
			const userId = localStorage.getItem('userId');
			data.createdBy = userId;

			if (!id) {
				id = doc(collection(this.firestore, 'organisations')).id;
			}

			if (data.imageLogo.includes('data:image/jpeg;base64,') || data.imageLogo.includes('data:image/jpg;base64,') || data.imageLogo.includes('data:image/png;base64,')) {
				data.imageLogo = await this.sharedService.getUrlForUploadedFile(data.imageLogo, `organisations/${id || data.id}/images/image.png`);
			}

			let docRef = doc(this.firestore, `organisations/${id}`);
			await setDoc(docRef, data);
			resolve(true);
		}).catch((error) => {
			console.log("addEditOrganization error: ", error);
			return false;
		});
	}

	getOrganisation() {
		// const userId = localStorage.getItem('userId');
		const orgQuery = query(collection(this.firestore, 'organisations'));
		return collectionData(orgQuery, {idField: 'id'}) as Observable<any>;
	}

	async deleteOrganisation(id: string) {
		return new Promise(async (resolve) => {
			const orgDel = doc(this.firestore, `organisations/${id}`);
			await deleteDoc(orgDel);
			resolve(true);
		}).catch((error) => {
			console.log("deleteOrganization error: ", error);
			return false;
		});
	}

	async saveOrgdata(data: any, id: string) {
		return new Promise(async (resolve) => {
			// console.log("data", data);
			// console.log("id", id);
			// const userId = localStorage.getItem('userId');
			// data.createdBy = userId;

			// if (!id) {
			// 	id = doc(collection(this.firestore, 'organisations')).id;
			// }
			let docRef = doc(this.firestore, `organisations/${id}`);
			data.updatedAt = new Date();
			await setDoc(docRef, data);
			resolve(true);
		}).catch((error) => {
			console.log("addEditOrganization error: ", error);
			return false;
		});
	}

}
